itsoftApp.createModule("linkOtherPage", function () {
    const module = this;

    const LinkOtherPage = function () {
        this.header = document.querySelector(".page-header");
        this.selectors = document.querySelectorAll('.js-link-other-page');
  
        this.time = 1000;
        
        if (this.selectors.length > 0) {
            this.init();
        }
    }

    LinkOtherPage.prototype.init = function () {
        const THIS = this;

        THIS.bindMethods();
        THIS.addListeners();

        window.addEventListener('pageshow', function(event) {
            if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
              const img = document.querySelector('.help-preview');
              const content = document.querySelector('.l-content');

              THIS.header.classList.add('js-fixed')
              document.body.style.overflow = "";
              THIS.setPadding("");

              if (img) {
                img.remove();
              }

              content.classList.remove('_hide');
            }
          });
    }

    LinkOtherPage.prototype.bindMethods = function () {
        const THIS = this;

        THIS.clickHandler = THIS.clickHandler.bind(THIS);
    }

    LinkOtherPage.prototype.addListeners = function () {
        const THIS = this;

        for (const el of THIS.selectors) {
            el.addEventListener('click', THIS.clickHandler);
        }
    }

    LinkOtherPage.prototype.clickHandler = function (e) {
        const THIS = this;

        e.preventDefault();

        const target = e.currentTarget;

        THIS.startAnim(target);
    }

    LinkOtherPage.prototype.startAnim = function (target) {
        const THIS = this;

    
        const curImg = target.querySelector('.card-help__img');
        const rect = curImg.getBoundingClientRect();
        const imgBox = document.createElement('DIV');
        imgBox.classList.add('help-preview');
        imgBox.style.top = rect.top + 'px';
        imgBox.style.left = rect.left + 'px';
        imgBox.style.width = curImg.clientWidth + 'px';
        imgBox.style.height = curImg.clientHeight + 'px';

        const img = document.createElement('IMG');
        img.classList.add('image');
        img.src = curImg.querySelector('img').src;

        imgBox.appendChild(img);
        document.body.appendChild(imgBox);

        THIS.header.classList.remove('js-fixed')
        THIS.setPadding(`${THIS.getScrollbarSize()}px`);
        document.body.style.overflow = "hidden";

        setTimeout(() => {
            const content = document.querySelector('.l-content');
            imgBox.classList.add('_active');
            imgBox.style.width = curImg.clientWidth * 2.35 + 'px';
            imgBox.style.height = curImg.clientHeight * 2.35 + 'px';
            content.classList.add('_hide');
        }, 1);

        setTimeout(() => {
            window.location.href = target.href;
        }, THIS.time);
    }

    LinkOtherPage.prototype.getScrollbarSize = function () {
        return window.innerWidth - document.body.offsetWidth;
    };

    LinkOtherPage.prototype.setPadding = function (property) {
        const header = document.querySelector(".l-header");

        document.body.style.paddingRight = property;

        if (header) {
            header.style.paddingRight = property;
        }
    };


    // new LinkOtherPage();
    module.callback = LinkOtherPage;
});